/**
 * The two pickers of "Copy data to…" (owner, 30.09.2026). Injected into the
 * DB Manager guest with Function.prototype.toString — self-contained ES5
 * (see treeRefresh.js). The copy itself runs host-side (extensions/dbCopyTable.js).
 */

/** Step 1 (only when another connection could be the target): which connection. */
export function copyTargetConnectionModal(sourceTable, currentId, candidates) {
  return {
    title: 'Copy data to…',
    subtitle: 'Copy every row of "' + sourceTable + '" — pick the connection of the target table',
    submitLabel: 'Next',
    fields: [
      {
        id: 'target',
        type: 'select',
        label: 'Target connection',
        required: true,
        defaultValue: currentId,
        options: candidates.map(function (c) {
          return { value: c.id, label: c.label + (c.id === currentId ? ' (this connection)' : '') };
        }),
      },
    ],
  };
}

/** Step 2: the target table and how to copy. */
export function copyTargetTableModal(sourceTable, tables, sameConnection) {
  var options = tables
    .filter(function (t) { return !(sameConnection && t === sourceTable); })
    .map(function (t) { return { value: t, label: t }; });
  return {
    title: 'Copy data to…',
    subtitle: sameConnection
      ? 'All rows of "' + sourceTable + '" in ONE server-side INSERT … SELECT — the columns must match'
      : 'All rows of "' + sourceTable + '" in chunks — the columns must match',
    submitLabel: 'Copy',
    fields: [
      { id: 'table', type: 'select', label: 'Target table', required: true, defaultValue: options.length ? options[0].value : '', options: options },
      {
        id: 'onConflict',
        type: 'select',
        label: 'Rows that already exist (same key)',
        defaultValue: 'fail',
        options: [
          { value: 'fail', label: 'Stop and copy nothing (default)' },
          { value: 'skip', label: 'Skip them, copy the rest' },
        ],
      },
      { id: 'emptyFirst', type: 'checkbox', label: 'Empty the target table first', defaultValue: false, hint: 'Deletes its rows in the same transaction as the copy.' },
    ],
  };
}
